import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import router from '../router'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: sessionStorage.getItem("ed543672Token"),
        loading: true,
        config: {
            baseUrlApi: process.env.VUE_APP_BASE_URL,            
            instituicao: {
                id: '',
                nome: '',
                participa_pre_matricula: ''
            },
            periodo: {
                id: '',
                nome: '',
                periodo_anterior_id: ''
            },
            parametros: {
                fase_matricula: '',
                periodo_letivo_situacao_academica: ''
            }
        },
        instituicoes: [],
        periodos: [],
        user: {
            imagem: '',
            name: '',
            email: '',
            tipo: '',
            instituicoes: []
        }
    },
    actions: {
        setInstituicao(context, value){
            return new Promise((resolve, reject) => {

                context.commit('setInstituicao', context.state.instituicoes[value]);
                resolve();
            })
        },
        setPeriodo(context, value){
            return new Promise((resolve, reject) => {

                context.commit('setPeriodo', context.state.periodos[value]);
                resolve();
            })
        },
        async getUser(context){

            try{

                let response = await axios.get(`${context.state.config.baseUrlApi}/api/sistema/initSistema`, context.getters.getHeaderAuth);

                //SETA AS CREDENCIAIS DO USUÁRIO LOGADO
                context.commit('setUser', response.data.user);

                //SETA A LISTAGEM DE PERÍODOS
                context.commit('setListPeriodos', response.data.periodos);

                //SETA O PERÍODO DO SISTEMA
                context.commit('setPeriodo', { id: response.data.parametros.periodo_letivo_base_id, nome: response.data.parametros.periodo_letivo_base_nome, periodo_anterior_id: response.data.parametros.periodo_anterior_id });

                //SETA OS PARÂMETROS DO SISTEMA
                context.commit('setParametros', {

                    fase_matricula: response.data.parametros.fase_matricula,
                    periodo_letivo_situacao_academica: response.data.parametros.periodo_letivo_situacao_academica
                });

                //SE O USER LOGADO PRECISA DE VÍNCULO COM INSTITUIÇÃO
                if(response.data.user.tipo <= 3 || response.data.user.tipo == 9){

                    if(sessionStorage.getItem('ed543672Instituicao')){

                        context.commit('setInstituicao', JSON.parse(sessionStorage.getItem("ed543672Instituicao")));
                        return false;
                    }

                    if(response.data.user.instituicoes.length == 1){

                        context.commit('setInstituicao', response.data.user.instituicoes[0]);

                    }else{

                        context.commit('setInstituicao', false);
                    }

                }else{

                    context.commit('updateLoading', false);

                    context.commit('setListInstituicoes', response.data.instituicoes);
                }

            }catch(e){

                context.commit('logout');
            }


        }
    },
    mutations: {
        clearInstituicaoSelected(state, value){

            state.instituicao.id = '';
            state.instituicao.nome = '';
        },
        setListInstituicoes(state, value){

            state.instituicoes = value;
        },
        setListPeriodos(state, value){

            state.periodos = value;
        },
        setToken(state, value){

            state.token = value;
        },
        updateLoading(state, value){

            state.loading = value;
        },
        setInstituicao(state, value){

            if(!value){

                state.config.instituicao = false;
                sessionStorage.removeItem('ed543672Instituicao');

            }else{

                state.config.instituicao = { id: value.id, nome: value.nome, participa_pre_matricula: value.participa_pre_matricula };
                sessionStorage.setItem('ed543672Instituicao', JSON.stringify({ id: value.id, nome: value.nome, participa_pre_matricula: value.participa_pre_matricula }));
            }

            state.loading = false;

        },
        setPeriodo(state, value){

            state.config.periodo = { id: value.id, nome: value.nome, periodo_anterior_id: value.periodo_anterior_id };

        },
        setParametros(state, value){

            state.config.parametros = value;

        },
        setUser(state, value){

            state.user = value;
        },
        logout(state, value){

            router.push('/login');
            state.config.instituicao = { id: '', nome: '' };
            state.token = null;
            state.loading = true;
            state.user = { imagem: '', name: '', email: '', tipo: '', instituicoes: [] };
            sessionStorage.removeItem('ed543672Token');
            sessionStorage.removeItem('ed543672Instituicao');
            window.eventBus = new Vue();
        },
        throwException(state, value) {

            console.log(String(value));
        }
    },
    getters: {
        getHeader: state => {

            let header = {
                'Content-Type': 'application/json',
                'Accept' : 'application/json'
            }
            return header;
        },
        getHeaderAuth: state => {

            let options = {

                headers : {
                    'Content-Type' : 'application/json',
                    'Accept' : 'application/json',
                    'Authorization' : `Bearer ${state.token}`
                }

            }
            return options;
        },
        getHeaderAuthExcel: state => {

            let options = {

                'responseType': 'blob',

                headers : {

                    'Authorization' : `Bearer ${state.token}`
                }

            }
            return options;
        },
        getHeaderFileAuth: state => {

            let options = {

                headers : {
                    'Content-Type' : ['application/json', 'multipart/form-data'],
                    'Accept' : 'application/json',
                    'Authorization' : `Bearer ${state.token}`
                }

            }
            return options;
        },
    }
})